const MIME_TO_EXTENSION: Record<string, string> = {
  "application/pdf": "pdf",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
  "image/gif": "gif",
};

export function triggerBrowserBlobDownload(blob: Blob, filename: string): void {
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}

function tryFilenameFromFilePath(filePath: string): string | null {
  const rawSegment = filePath.split(/[/\\]/).pop()?.split("?")[0]?.trim();
  if (!rawSegment) return null;

  try {
    const decoded = decodeURIComponent(rawSegment);
    if (/\.\w{2,5}$/i.test(decoded)) return decoded;
  } catch {
    if (/\.\w{2,5}$/i.test(rawSegment)) return rawSegment;
  }

  return null;
}

export function buildPreOrderDocumentDownloadName(
  filePath: string,
  fileIndex: number,
  mimeType: string
): string {
  const fromPath = tryFilenameFromFilePath(filePath);
  if (fromPath) return fromPath;

  const extension = MIME_TO_EXTENSION[mimeType] || "bin";
  return `pedido-medico-arquivo-${fileIndex + 1}.${extension}`;
}
